<main id="main">
    <div class="row-md-2" id="header">
        <app-header (newItemEvent)="sideBarDisplay($event)" (selectedlanguage)="language($event)" (sidebarToggle)="onSidebarToggle($event)" [formConfig]="formConfig"></app-header>
    </div>
    <div class="d-md-flex row-md-10">
        <div [ngClass]="{'col-md-2':displaySideBar, 'mobile-sidebar': true, 'mobile-sidebar-open': sidebarOpen}" id="sidebar">
            <app-side-bar class="d-md-block" [ngClass]="{'d-block': sidebarOpen, 'd-none': !sidebarOpen}" *ngIf="displaySideBar" [formConfig]="formConfig"></app-side-bar>
        </div>
        <div [ngClass]="{'col-md-8':displaySideBar,'col-md-10':!displaySideBar}" class="main-content">
            <app-overview [formConfig]="formConfig"></app-overview>
        </div>
        <div class="d-none d-md-block col-md-2" id="sidebar"> 
            <app-welcome-bar></app-welcome-bar>
        </div>
    </div>
    <div class="sidebar-overlay" [class.active]="sidebarOpen" (click)="onSidebarToggle(false)"></div>
</main>
